module.exports = __webpack_public_path__ + "img/struc-pilecap.3ed8be52.png";